module.exports = __webpack_public_path__ + "media/images/area/feature/setouchi/related/en/5-fffb63822f302095a544cbcdf380eeb5.jpg";